import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

export const initGA = (): void => {
  if (!GA_MEASUREMENT_ID) {
    console.warn('[Analytics] REACT_APP_GA_MEASUREMENT_ID is not set — tracking disabled.');
    return;
  }
  ReactGA.initialize(GA_MEASUREMENT_ID, {
    gaOptions: {
      // Generates a persistent client ID stored in the browser cookie (_ga)
      // This is the closest thing to a "visitor ID" available without login
      cookieDomain: 'auto',
      cookieExpires: 63072000, // 2 years in seconds
    },
  });
};

/** Track a page view. Call this on every route change. */
export const trackPageView = (path: string, title?: string): void => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.send({ hitType: 'pageview', page: path, title });
};

/** Track a custom event (e.g. button clicks, form submits). */
export const trackEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number
): void => {
  if (!GA_MEASUREMENT_ID) return;
  ReactGA.event({ category, action, label, value });
};

/** Return the GA client ID for the current visitor (unique per browser). */
export const getClientId = (): string => {
  try {
    // GA4 stores the client ID in the _ga cookie: GA1.1.<clientId>
    const match = document.cookie.match(/_ga=GA\d+\.\d+\.(\d+\.\d+)/);
    return match ? match[1] : 'unknown';
  } catch {
    return 'unknown';
  }
};
